export class NumericValue {
    constructor(string, type) {
        this.string = string;
        this.type = type;
    }
}
export function nv(string) {
    return new NumericValue(string, "bigDecimal");
}
